// /press: the press kit, for journalists, bloggers and YouTubers writing about our products, and /press/contact, their
// inquiries (and review license requests).
export const press = {
    page: {
        title: 'Press',
        description: 'Logos, images, fact sheets and reviewer\'s notes for Tristar Advanced Software products, and how to reach us for interviews and review licenses.',
        intro: "Everything you need to write about Tristar Advanced Software and our products: logos, images, fact sheets and reviewer's notes. Use them freely in your coverage. For anything else, an interview or a review license, <link>get in touch</link>.",
        about: {
            title: 'About Tristar',
            // The site's own wording, until an administrator writes theirs (Administration > Settings > Press page).
            paragraphs: [
                'Tristar Advanced Software makes audio software for musicians: instruments to play in your DAW or on their own.',
                'Tristar was founded by a software engineer with 30 years of experience building software, who has been a musician for even longer. Its products are made to be played: quick to get a sound out of, deep enough to keep exploring, and looked after by the people who made them.',
                'Tristar Advanced Software, LLC is based in Ohio, in the United States.'
            ]
        },
        logos: {
            title: 'Logos',
            download: 'Download logos (ZIP)',
            contents: 'Horizontal and stacked logos, the wordmark, the star on its own, and the app icon, as PNGs in color and in white.',
            usageTitle: 'Using the logos',
            usage: [
                "Please don't recolor, stretch, rotate or add effects to the logos.",
                'Use the white versions on dark or busy backgrounds, and the color ones on light backgrounds.',
                'Leave clear space around a logo of at least the height of the star.'
            ]
        },
        products: {
            title: 'Products',
            none: 'Press kits for our products will be here soon.',
            productPage: 'Product page',
            imagePack: 'Images (ZIP, {size})',
            imagePackHelp: '{count} images, with their descriptions in alt-text.txt.',
            reviewerNotes: "Reviewer's notes (PDF, {size})",
            features: 'Features',
            factSheet: 'Fact sheet',
            facts: {
                developer: 'Developer',
                price: 'Price',
                version: 'Current version',
                versionValue: '{version}, released {date}',
                platforms: 'Platforms',
                formats: 'Formats',
                trial: 'Free trial',
                trialValue: 'Yes: free to download, it runs as a demo until it is activated with a license key',
                demos: 'Audio demos',
                demosValue: 'On the <link>product page</link>'
            }
        },
        boilerplate: {
            title: 'Boilerplate',
            intro: 'A paragraph about the company, to use as it is:',
            // For approval: the boilerplate.
            text: 'Tristar Advanced Software is an independent audio software company based in Ohio, USA. Founded by a software engineer with 30 years of experience and a lifelong musician, Tristar makes instruments to play in your DAW or on their own, starting with Astrel, a five-voice analog-style polysynth for Windows, macOS and Linux. Learn more at tristaradvanced.com.',
            copy: 'Copy boilerplate'
        },
        contact: {
            title: 'Press inquiries and review licenses',
            text: 'Writing a review, a feature or a video? Ask us for a review license, an interview or anything this page is missing.',
            button: 'Contact us for press'
        }
    },
    // /press/contact: a press inquiry, which can ask for a review license. A support ticket underneath (category 'press').
    contact: {
        title: 'Press inquiries',
        description: 'Journalists, bloggers and YouTubers: ask Tristar Advanced Software for a review license, an interview or press materials.',
        intro: "Writing about our products, or making a video? Tell us about it here: a review license, an interview, or anything the <link>press page</link> doesn't have. We'll email you a private link where you'll see our replies.",
        signedInIntro: "Writing about our products, or making a video? Tell us about it here: a review license, an interview, or anything the <link>press page</link> doesn't have. Our replies will be with your support tickets.",
        // Signed in: the account's address is the one used, and checked against the outlet's.
        signedInEmail: "We'll reply to your account's address, <strong>{email}</strong>. Signed in with a personal address? <signOut>Sign out</signOut> to use your address at the outlet instead.",
        name: 'Your name',
        email: 'Email address',
        emailHelp: "Use your address at the outlet if you have one: it lets us confirm who you are, and speeds things up. We'll send a link to your inquiry here; it's the only way to see our replies.",
        publication: 'Publication or channel',
        publicationHelp: 'The magazine, website, blog, podcast or YouTube channel you write or make videos for.',
        product: 'Product',
        noProduct: 'No particular product',
        reviewLicense: 'Request a review license',
        reviewLicenseHelpSignedIn: "A review license is free and lasts 30 days. It's issued to your Tristar account, and works on two computers. Meanwhile, you can download the free demo from the product's page.",
        reviewLicenseHelp: "A review license is free and lasts 30 days. It's issued to a Tristar account under the email address above, made for you if you don't have one, and works on two computers. Meanwhile, you can download the free demo from the product's page.",
        outletUrl: "The outlet's or channel's address",
        outletUrlPlaceholder: 'https://',
        role: 'Your role',
        rolePlaceholder: 'Reviews editor, freelance writer, channel host…',
        subject: 'Subject',
        body: 'Tell us about it',
        bodyHelp: 'What you have in mind, and when you plan to publish. Please write in English.',
        submit: 'Send inquiry',
        sent: 'Your inquiry has been sent.',
        checkEmail: "Thank you: your inquiry has been sent. We've emailed a link to it to {email}. Open it to read our replies, or to add details.",
        tooMany: "You've sent a lot of messages today. Please try again tomorrow.",
        tooManySignedOut: 'Too many messages have been sent from your network today. Please try again tomorrow.',
        unavailable: "Inquiries can't be sent right now. Please try again later.",
        problems: {
            name: 'Enter your name.',
            email: 'Enter your email address.',
            publication: 'Enter the publication or channel.',
            product: 'Choose the product to review.',
            outletUrl: 'Enter its address, starting with https://.',
            role: 'Enter your role.',
            subject: 'Enter a subject.',
            body: 'Tell us what you have in mind.'
        }
    }
};

export type PressMessages = typeof press;
